import React from "react";
import {
    Breadcrumb,
    Icon,
    Input,
    Layout,
    List
} from "antd";
import {Link} from "react-router-dom";

import './index.less';
import {repositoryApi} from "../../../../api";
import {AVATAR} from "../../../../utils/constant";

const {Content} = Layout;
const {Search} = Input;
const {
    reqArticleSearch
} = repositoryApi;

const IconText = (props) => {
    const {type, text, title} = props
    return (
        <span className={type} title={title}>
            <Icon type={type} style={{ marginRight: 8 }} />
            {text}
        </span>
    );
};


export default class Home extends React.Component{
    state = {
        article_list: [],
    };

    handleSearch = async (value) => {
        const response = await reqArticleSearch({
            key: value
        });
        if(response && response.data) {
            const data = response.data;
            let result = [];
            for(let i = 0; i < data.length; i++) {
                result.push({
                    id: data[i]._id,
                    name: data[i].title,
                    avatar: data[i].creator.avatar || AVATAR,
                    description: data[i].creator.name,
                    href: `/repository/article/detail/${data[i]._id}`,
                    read_num: data[i].read_num || 0,
                    answer_num: data[i].answer_num || 0
                });
            }
            this.setState({
                article_list: result
            });
        }
    };

    render() {
        return (
            <>
                <Breadcrumb
                    style={{
                        padding: '24px 24px 0',
                        marginTop: '64px',
                    }}>
                    <Breadcrumb.Item>
                        首页
                    </Breadcrumb.Item>
                </Breadcrumb>

                <Content style={{margin: '24px 16px 0'}}>
                    <div className="search">
                        <Search
                            className="search-input"
                            placeholder="搜索"
                            onSearch={this.handleSearch}
                            enterButton
                            style={{marginTop: this.state.article_list.length ? 30 : 100}}
                        />

                        <List
                            className="search-list"
                            itemLayout="vertical"
                            size="large"
                            dataSource={this.state.article_list}
                            renderItem={item => (
                                <List.Item
                                    key={item.id}
                                    actions={[
                                        <IconText type="read" text={item.read_num} key="list-vertical-read" title="阅读量" />,
                                        <IconText type="message" text={item.answer_num} key="list-vertical-message" title="回答数" />,
                                    ]}
                                >
                                    <Link to={item.href}>{item.name}</Link>
                                </List.Item>
                            )}
                        />
                    </div>
                </Content>
            </>
        );
    }
}